"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _moize = require("moize");
var interop_1 = require("./interop");
var logic_1 = require("./logic");
var rxjs_1 = require("rxjs");
var moizeDefault = interop_1.interopRequireDefault(_moize);
var defaultCreateSelectorAsync = createSelectorCreator({ deepEquals: false });
exports.createDeepSelector = createSelectorCreator({ deepEquals: true });
//**********************************
//Termina codigo autogenerado por genselectors.ts
//**********************************
function createSelector() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var func = defaultCreateSelectorAsync;
    return func.apply(void 0, __spread(args));
}
exports.createSelector = createSelector;
function createSelectorCreator(options) {
    var selectorArr = createSelectorAsyncArrCreator(options);
    return function createSelectorAsync() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var selectors = args.slice(0, args.length - 1);
        var combiner = args[args.length - 1];
        return selectorArr(selectors, combiner);
    };
}
exports.createSelectorCreator = createSelectorCreator;
function getSelectorValueClearMemoOnError(valueThunk, clearMemo) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var result;
    try {
        result = valueThunk.apply(void 0, __spread(args));
    }
    catch (error) {
        //Error sincrono;
        clearMemo();
        throw error;
    }
    if (logic_1.isObservable(result)) {
        var r_1 = result;
        //Resultado observable
        return new rxjs_1.Observable(function (subs) {
            var obs = r_1.catch(function (err) {
                clearMemo();
                throw err;
            });
            obs.subscribe(subs);
        });
    }
    else if (logic_1.isPromise(result)) {
        //Resultado promesa
        return result
            .then(function (x) { return x; }, function (error) {
            clearMemo();
            return Promise.reject(error);
        });
    }
    else {
        //Resultado síncrono
        return result;
    }
}
function allSync(x) {
    var anyAsync = logic_1.any(x, function (x) { return logic_1.isObservable(x) || logic_1.isPromise(x); });
    return !anyAsync;
}
function createSelectorAsyncArrCreator(options) {
    var moize = moizeDefault({ equals: options.deepEquals ? logic_1.deepEquals : undefined, maxSize: 1 });
    /**Crea un selector con un funcionamiento similar al de reselect.createSelector, pero con la memoización comparando el resultado resuelto de la promesa en lugar de simplemente la promesa*/
    return function createSelectorAsyncArr(selectors, combiner) {
        var clearMemos = function () {
            memoCombiner.clear();
            memoAsyncCombiner.clear();
        };
        var memoCombiner = moize(combiner);
        var asyncCombiner = (function () {
            var resultThunk = (function () {
                var asyncS = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    asyncS[_i] = arguments[_i];
                }
                if (allSync(asyncS)) {
                    //Todos los argumentos son SINCRONOS
                    return memoCombiner.apply(void 0, __spread(asyncS));
                }
                else {
                    //Algunos argumentos son OBSERVABLE o PROMISE
                    var argsRx = asyncS.map(function (x) { return logic_1.toObservable(x); });
                    //Observable de los argumentos
                    var argRxLatest = rxjs_1.Observable.combineLatest.apply(rxjs_1.Observable, __spread(argsRx));
                    //Por cada cambio de argumento observamos el resultado del memoCombiner
                    var ret_1 = argRxLatest.map(function (x) {
                        return logic_1.toObservable(memoCombiner.apply(void 0, __spread(x)));
                    }).switch(); //Si llega un nuevo argumento ignoramos los resultados de los observables anteriores con el switch
                    return ret_1;
                }
            });
            return function () {
                var asyncS = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    asyncS[_i] = arguments[_i];
                }
                return getSelectorValueClearMemoOnError.apply(void 0, __spread([resultThunk, clearMemos], asyncS));
            };
        })();
        var memoAsyncCombiner = moize(asyncCombiner);
        var ret = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var myArgs = selectors.map(function (x) { return x.apply(void 0, __spread(args)); });
            return memoAsyncCombiner.apply(void 0, __spread(myArgs));
        };
        return ret;
    };
}
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/filtermatrix/~/keautils/dist/selectors.js
// module id = 2171
// module chunks = 0